module.exports = __webpack_public_path__ + "static/img/m-cash-insta.ffad102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cash/m-cash-insta.png
// module id = dxSa
// module chunks = 1